import dayjs from 'dayjs'

import { filter, first, last } from 'lodash'
import { RENTALOBJECT_TYPES } from '@/config/constants'
import { PARKING_FILTER_TYPES } from '@/config/constants'


export default {
  // implementera denna i varje arv.
  // då man man själv välja vart details ska komma ifrån
  // data(){
  //   return {
  //     details : null
  //   }
  // },
  methods : {
    removeTexts(value) {
      if (value.caption == "Platsnr"|| value.caption == "Barnvagnsrum" || value.caption == "Porttelefon" ||  value.caption == "Cykelrum" ||  value.caption == "Cykelrum" ||  value.caption == "Förråd, placering" ||  value.caption == "Förråd, tillträde" ||  value.caption == "Återvinningsrum" || value.caption == "Entréport, tillträde" || value.caption == "Gemensam tvättstuga" || (value.caption.includes("Fintvätt") && value.caption.includes("(adress)")) || (value.caption.includes("Grovtvätt") && value.caption.includes("(adress)")) )
        return value;
    }
  },

  computed : {
    /**
     * Första bilden som heter "Ritning"
     */
    blueprint(){
      if(! (this._rentalObject && this._rentalObject.images && this._rentalObject.images.length > 0))
        return

       const img = this._rentalObject.images.find(image => image.subTypeCaption == 'Ritning');

       if(img)
        return img.url;
    },

    blueprint3d(){
      if(! (this._rentalObject && this._rentalObject.images && this._rentalObject.images.length > 0))
        return

      const images = this._rentalObject.images.filter(image => image.subTypeCaption == 'Ritning 3D');

      return images;
    },

    rentalObjectCode(){
      if(this._rentalObject)
        return this._rentalObject.rentalObjectCode;
    },

    /**
     * Typ, "parking", "apartment"
     */
    objectType(){
      if(this._rentalObject)
        return this._rentalObject.objectType;
    },

    /**
     * Platsnummer
     */
    parkingNumber(){
      if(this._rentalObject)
        return this._rentalObject.parkingNumber;
    },

    /**
     * vatArea
     */
    vatArea(){
      if(this._rentalObject)
        return this._rentalObject.vatArea;
    },

    /**
     * vatAdded
     */
    vatAdded(){
      if(this._rentalObject)
        return this._rentalObject.vatAdded;
    },

    /**
     * rentalObjectType
     */
    realEstateObjectTypeCode(){
      if(this._rentalObject)
        return this._rentalObject.realEstateObjectTypeCode;
    },

    /**
     * har publishedTo passerat?
     */
    publishedToHasPast(){

      if(!this._rentalObject || ! this._rentalObject.publishedTo)
        return false;

      return dayjs(this._rentalObject.publishedTo).isBefore();
    },

    /**
     * Sista anmälningsdatum, t.ex. 2018-12-15T23:59:59
     */
    publishedTo(){
      if(this._rentalObject)
        return this._rentalObject.publishedTo;
    },

    /**
     * Inflyttningsdatum. t.ex. 2018-12-15 eller idag
     */
    vacantFromText(){

      if(!this._rentalObject || !this._rentalObject.vacantFrom)
        return;

      const formatedDate = dayjs(this._rentalObject.vacantFrom).format('YYYY-MM-DD');

     /* if(this.flexibleAccess) {
        return "Flexibelt tillträde";
      }*/

      if(dayjs(formatedDate).isBefore()){
        if(this.objectType == RENTALOBJECT_TYPES.APARTMENT || this.objectType == RENTALOBJECT_TYPES.STUDENT_APARTMENT)
          return "Inflyttning omgående";

        return "Omgående"
      }


      return formatedDate;
    },

    /**
     * Har LastReply passerat?
     */
    lastReplyHasPast(){
      if(! this._rentalObject || !this._rentalObject.lastReplyDate)
        return false;

      return dayjs(this._rentalObject.lastReplyDate).isBefore();
    },

    status(){
      return 'handläggs';
    },

    /**
     * URL till bild
     */
    image(){
      var ret = null;

      if(this._rentalObject && this._rentalObject.images && this._rentalObject.images.length > 0) {
        ret = first(filter(this._rentalObject.images, { subTypeCaption: "Fotografi" }));
      }

      if(ret)
        return ret.url;

      return 'https://gavlegardarna.blob.core.windows.net/images/2018/11/placeholder.jpg';
    },


    allImages() {
      if(this._rentalObject && this._rentalObject.images && this._rentalObject.images.length > 0) {
        return this._rentalObject.images;
      }else {
        return false;
      }
    },

    /**
     * Lista med alla bilder, som inte är ritningar
     */
    onlyImages(){
      var ret = [];
      if(this._rentalObject && this._rentalObject.images && this._rentalObject.images.length > 0) {
        ret = filter(this._rentalObject.images, { subTypeCaption: "Fotografi" });
      }

      if(ret.length === 0) ret = ['https://gavlegardarna.blob.core.windows.net/images/2018/11/placeholder.jpg'];
      return ret;
    },

    /**
     * Typ, "Hantverkargatan 12
     */
    address(){
      if(!this._rentalObject)
        return;

      if(this._rentalObject.address)
        return this._rentalObject.address;

      return this._rentalObject.address1;
    },

    /**
     * Typ, "Sicksackvägen 23, 806 32"
     */
    fullAddress(){
      if(!this._rentalObject)
        return;

      if(this._rentalObject.address)
        return this._rentalObject.address;

      return this._rentalObject.address1 +', ' + this._rentalObject.address3;
    },

    longitude(){
      if(!this._rentalObject)
        return;

      if(this._rentalObject.coordinates) return this._rentalObject.coordinates.longitude;
      return;
    },

    latitude(){
      if(!this._rentalObject)
        return;

      if(this._rentalObject.coordinates) return this._rentalObject.coordinates.latitude;
      return;
    },


    /**
     * Området, typ "Bomhus" eller "Centrala Gävle"
     */
    neighbourhood() {
      if(!this._rentalObject)
        return;

      if(this._rentalObject.area) return this._rentalObject.area
      else return this._rentalObject.neighbourhood;
    },


    /**
     * Vilken våning
     */
    staircase() {
      if(!this._rentalObject)
        return;

      return this._rentalObject.staircase;
    },

    /**
     * Typ, "Trygghetsboende"
     *
     * Spec:
     * 55+ = LGH2
     * Trygghetsboende = LGH4
     * Startbo = LGH5
     * Studentbostad = LGH20
     * Ungdomsförtur 18-22 år = LGH31
     * Ungdomsförtur 23-26 år = LGH32
     */

    subtypeCaption(){
      if(!this._rentalObject)
        return;

      let type = this._rentalObject.rentalObjectType ? this._rentalObject.rentalObjectType : this._rentalObject.rentalObjectTypeCode;

      switch(type){
        case 'LGH2':
          return '55+';
        case 'LGH4':
          return 'Trygghetsboende';
        case 'LGH5':
          return 'Startbo';
        case 'LGH20':
          return 'Studentbostad';
        case 'LGH6':
          return 'Rivningskontrakt';
        case 'LGH31':
          return 'Ungdomsförtur 18-22 år';
        case 'LGH32':
          return 'Ungdomsförtur 23-26 år';
      }

      return  ;
    },

    /**
     * Typ, "trygghetsboende"
     */
    subtypeCaptionClass(){
      if(!this._rentalObject)
        return;

      if (this.subtypeCaption === '55+')
        return 'femtiofemplus';

      if (this.subtypeCaption === 'Ungdomsförtur 18-22 år')
        return 'ungdomsfortur1822';

      if (this.subtypeCaption === 'Ungdomsförtur 23-26 år')
        return 'ungdomsfortur2326';

      if(this.subtypeCaption)
          return this.subtypeCaption.toLowerCase().replace('å','a').replace('ä','a').replace('ö','o');
    },

    /**
     * Typ "Bostad", "Studentbostad", "Fordonsplats", "Lokal"
     */
    typeCaption(){
      if(!this._rentalObject)
        return;

      if(this._rentalObject.caption)
        return this._rentalObject.caption;

      return this._rentalObject.rentalObjectTypeCaption;
    },

    /**
     * Typ "1 rum och kök", "Varmgarage"
     */
    subCaption(){
      if(!this._rentalObject)
        return;

      // if(this.typeCaption == 'Lokal')
      //   return this._rentalObject.rentalObjectTypeName;

      return this._rentalObject.subCaption;
    },

    /**
     * Typ "Direkt, förråd"
     */
    waitingListType(){
      if(!this._rentalObject || !this._rentalObject.waitingListType)
        return;

      return this._rentalObject.waitingListType;
    },

    /**
     * Typ "Direkt"
     */
    waitingListTypeCaption(){
      if(!this._rentalObject || !this._rentalObject.waitingListType)
        return;

      return this._rentalObject.waitingListType.replace(/,.+/,'');
    },

    /**
     * Typ, 22
     */
    quantityBRA(){
      if(!this._rentalObject)
        return;

      return this._rentalObject.quantityBRA;
    },

    /**
     * Typ, 2939
     */
    monthRent(){
      if(!this._rentalObject)
        return;

      return Math.round(this._rentalObject.monthRent);
    },

    /**
     * Egenskaper på objektet. Typ [{ caption: "Balkong", value:1 }, { caption: "Bredbandsanslutning", value:1 }, ],
     */
    rentProperties(){
      if(!this._rentalObject)
        return [];

      return this._rentalObject.rentProperties;
    },

    /**
     * Ännu mer data om objektet. ["Tidigare objektsnummer 1220179", "3. Fintvätt 1 (objnr) 1306-003-01-9001",…]
     * Idagsläget samma som texts, men det är fel och kommer bli rätt sen.
     *
     * Används om objektet INTE är ett "publishedRentalObject"
     */
    webNotesRentalObject(){

      if(!this._rentalObject || !this._rentalObject.webNotesRentalObject)
        return [];

      return this._rentalObject.webNotesRentalObject;
    },

    texts(){

      if(!this._rentalObject || !this._rentalObject.texts)
        return [];

      return this._rentalObject.texts.filter(this.removeTexts);
    },

    webNotesRealEstate(){
      if(!this._rentalObject || !this._rentalObject.webNotesRealEstate)
        return [];

      return this._rentalObject.webNotesRealEstate
    },

    /**
     * Kolla om detta rentalObject hämtats som ett "publishedRentalObject" eller inte
     */
    isPublishedRentalObject(){
      if(! this._rentalObject)
        return;

      return this._rentalObject.rentalObjectTypeCode === undefined;
    },

    /**
     * Antal intresseanmälningar på objektet
     */
    numberOfApplications(){
      if(! this._rentalObject)
        return;

      return this._rentalObject.numberOfApplications;
    },

    /**
     * Är objektet
     * */
    fastAccess(){
      if(! this._rentalObject)
        return;

      //omgående tillträde
      const formatedDate = dayjs(this._rentalObject.vacantFrom).format('YYYY-MM-DD');

      //snabb inflytt
      //const formatedDate = dayjs(this._rentalObject.vacantFrom).subtract(14, 'days').format('YYYY-MM-DD');
      if(dayjs(formatedDate).isBefore()){
        return true
      }

      return false;

     // return this._rentalObject.vacantFromTs <= new Date().getTime() + 1209600000;
    },

    flexibleAccess(){
      if(! this._rentalObject)
        return;

      let type = this._rentalObject.rentalObjectType ? this._rentalObject.rentalObjectType : this._rentalObject.rentalObjectTypeCode;

      if (type == "LGH9") {
        return true
      }

      return false;

      // return this._rentalObject.vacantFromTs <= new Date().getTime() + 1209600000;
    },

    queueText(){
      if(! this._rentalObject || ! this._rentalObject.queuePointIndex || ! this._rentalObject.queuePointsOnIndex)
        return;

      return  'Den som är på plats '+ this._rentalObject.queuePointIndex +' i kön har '+this._rentalObject.queuePointsOnIndex+' poäng'
    }
  }
}
